module.exports = __webpack_public_path__ + "static/media/paletteFromColor.5a5a179f.mov";